// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"af2b132e","966":"bd78d711"}[chunkId] + ".chunk.js";
};